import React, { useContext, useEffect, useState } from "react";
import { Container } from "semantic-ui-react";
import { AgGridReact } from "ag-grid-react/lib/agGridReact";
import { observer } from "mobx-react-lite";
import WorkOrderStore from "../../../../app/stores/workorderStore";

interface IProps {}

const WorkOrderSORSGrid: React.FC<IProps> = () => {
  const workorderStore = useContext(WorkOrderStore);
  const { selectedWorkOrderSors: workorderSors } = workorderStore;
  const [sorList, setSorList] = useState([{}]);
  const { selectedWorkOrder: workorder } = workorderStore;

  useEffect(() => {
    if (workorder != null) {
      setSorList(workorderSors);
    }
  }, [workorderSors,workorder]);

  return (
    <Container>
      <div
        className="ag-theme-material"
        style={{ height: "200px", width: "100%" }}
      >
        <AgGridReact
          enableColResize={true}
          enableSorting={true}
          colResizeDefault={true}
          columnDefs={SorCols}
          rowData={sorList}
        />
      </div>
    </Container>
  );
};

const SorCols = [
  {
    headerName: "Description",
    field: "SORDescripion",
    width: 420
  },
  { headerName: "Qty", field: "SORQty", width: 100 },
  { headerName: "SOR", field: "SORCode", width: 100 },

  {
    headerName: "Value",
    field: "SORValue",
    width: 150,

  }
];





export default observer(WorkOrderSORSGrid);
